/**
 * @desc 广告模块
 */
const bannerList = r => require.ensure([], () => r(require('../views/banner/BannerList.vue')), 'bannerList');

export default [
  //广告列表
  {
    name: 'bannerList',
    path: '/bannerList',
    component: bannerList,
    meta: { title: '广告列表' },
  },
]